// extracted by mini-css-extract-plugin
export default {"row":"Earning_row__M7Bsk","col":"Earning_col__sw6wU","card":"Earning_card__yTQcw"};